// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#safety-confirm-register-confirm #title{white-space:pre-wrap;word-wrap:break-word}#safety-confirm-register-confirm .back-btn,#safety-confirm-register-confirm .register-btn{min-width:84px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
